(() => {
  const selector = '.btn.btn--style-solid:not(.button-with-state)';
  const lightValues = new Set([
    '#fff',
    '#ffffff',
    'white',
    'rgb(255,255,255)',
    'rgba(255,255,255,1)'
  ]);
  const darkValues = new Set([
    '#000',
    '#000000',
    'black',
    'rgb(0,0,0)',
    'rgba(0,0,0,1)'
  ]);

  const normalizeColor = (value) =>
    (value || '').trim().toLowerCase().replace(/\s+/g, '');

  const classifyButton = (button) => {
    if (!(button instanceof Element)) return;

    const solidBackground = normalizeColor(
      getComputedStyle(button).getPropertyValue('--color-solid-button-background')
    );

    button.classList.remove('humble-cta-light', 'humble-cta-dark');

    if (lightValues.has(solidBackground)) {
      button.classList.add('humble-cta-light');
    } else if (darkValues.has(solidBackground)) {
      button.classList.add('humble-cta-dark');
    }
  };

  const classifyWithin = (root) => {
    if (!root) return;

    if (root instanceof Element && root.matches(selector)) {
      classifyButton(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll(selector).forEach(classifyButton);
    }
  };

  const classifyAll = () => classifyWithin(document);

  const startObserver = () => {
    if (!document.body) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            classifyWithin(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      classifyAll();
      startObserver();
    }, { once: true });
  } else {
    classifyAll();
    startObserver();
  }

  document.addEventListener('shopify:section:load', (event) => {
    classifyWithin(event.target);
  });
})();
